<template>
  <v-container>
    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-text-field
                prepend-icon="mdi-magnify"
                v-model="title"
                label="Filter by item name ..."
            />
          </v-col>
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-select
                prepend-icon="mdi-cube"
                v-model="brandid"
                @change="getList()"
                item-text="text"
                label="Filter by brand"
                :items="brands"
                return-object
            />
          </v-col>
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-select
                prepend-icon="mdi-sitemap"
                v-model="catid"
                @change="getList()"
                item-text="text"
                label="Filter by category"
                :items="cats"
                return-object
            />
          </v-col>
          <v-col>
            <v-btn @click="submit" dark color="indigo">
              <v-icon class="mr-1">mdi-chart-box-outline</v-icon> Show report
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
    <v-row v-if="showTable">
      <v-col cols="12">
        <v-data-table
            :footer-props="{
                'items-per-page-options': [-1]
             }"
            :items-per-page="-1"
            :search="title"
            :loading="isloading"
            :loading-text="loadingtext"
            :headers="headers"
            :items="items"
            ref="tbl"
        >

          <template v-slot:item.totalcost="{ item }">
            <strong>${{ getTotalCost(item.quan,item.cost) }}</strong>
          </template>


          <template v-slot:item.totalprice="{ item }">
            <strong>${{ getTotalCost(item.quan,item.price) }}</strong>
          </template>


        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="showTable" class="mb-4">
      <v-col cols="6">
        <v-sheet class="text-center font-weight-bold">
          Total items cost: ${{ grandcost }}
        </v-sheet>
      </v-col>
      <v-col cols="6">
        <v-sheet class="text-center font-weight-bold">
          Estimated revenue after sales: ${{ grandprice }}
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "StoreReport",
  computed: {
    totalprofit() {
      var total = 0;
      this.items.forEach(e => {
        //console.log(e);
        total += parseInt(e.profit.replace(",",""));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    grandprice() {
      var total = 0;
      this.items.forEach(e => {
        total += (parseInt(e.price) * parseInt(e.quan));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    grandcost() {
      var total = 0;
      this.items.forEach(e => {
        total += (parseInt(e.cost) * parseInt(e.quan));
      })
      return total.toLocaleString('us', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
  },

  methods: {
    getTotalCost(quan,cost) {
      return (parseInt(quan) * parseInt(cost))
    },
    getList() {
      this.isloading = true;
      __HTTP(
          "?do=list&type=store",
          JSON.stringify({
            keyword: this.search,
            catid: this.catid != null ? this.catid.value : "",
            brandid: this.brandid != null ? this.brandid.value : ""
          }),
          FormHeader,
          res => {
            console.log(this.brandid);
            this.isloading = false;
            this.items = res;
          }
      );
    },
    getBrands() {
      this.loading = true;
      __HTTP("?do=getbrands", "", FormHeader, res => {
        this.isloading = false;
        this.brands = [{ text: "All", value: 0 }].concat(res);
      });
    },
    getCats() {
      this.loading = true;
      __HTTP("?do=getcats", "", FormHeader, res => {
        this.isloading = false;
        this.cats = [{ text: "All", value: 0 }].concat(res);
      });
    },
    submit() {
      this.getList();
      this.showTable = true
    }


  },
  created() {
    this.$store.state.title = "Store Report";
    //this.getList();
    this.getCats();
    this.getBrands();
  },
  components: {},
  data: () => ({
    search: "",
    isloading: false,
    showTable: false,
    catid: null,
    brandid: '',
    brands: [],
    cats: [],

    modal: false,
    count: 0,
    headers: [
      {
        sortable: true,
        text: "#",
        value: "id"
      },
      {
        sortable: true,
        text: "Item title",
        value: "title"
      },
      {
        sortable: true,
        text: "Category",
        value: "catid.text"
      },
      {
        sortable: true,
        text: "Cost",
        value: "cost"
      },
      {
        sortable: true,
        text: "Price",
        value: "price"
      },
      {
        sortable: true,
        text: "Quantity",
        value: "quan"
      },
      {
        sortable: false,
        text: "Total Item Cost",
        value: "totalcost"
      },
      {
        sortable: false,
        text: "Item Estimated Revenue",
        value: "totalprice"
      },
      {
        sortable: true,
        text: "Brand",
        value: "brandid.text"
      },
      {
        sortable: true,
        text: "Notes",
        value: "notes"
      }
    ],
    loadingtext: "Please wait while loading data ...",
    items: [],
    //today: new Date(),
    dates: [],
    title: '',
  })
};
</script>
